module.exports = __webpack_public_path__ + "img/xufang.5cacacc7.jpg";